@if (mode === 'list') {
  <icc-list
    [searchable]="true"
    [items]="combinedModels"
    [tabs]="modelCategories$ | async"
    [itemTemplate]="'itemImgTitle'"
    [selected]="selectedModelForSashActive$ | async"
    (showInfo)="showInfo($event)"
    (select)="selectModel($event)"
    itemImgHeight="high"
  ></icc-list>
}
@if (mode === 'all') {
  @if (doorActiveModelBox?.show) {
    <icc-select-box
      [title]="doorActiveModelBox?.title"
      [description]="doorActiveModelBox?.name"
      [imageUrl]="doorActiveModelBox?.img"
      [buttonText]="'INTERFACE|Zmień' | translate"
      [buttonText2]="((doorActiveModelBox.type === 'deco_panels' ) && 'INTERFACE|Opcje' | translate ) || ((doorActiveModelBox.type === 'door_panels') && !isActiveModelButton2Disabled() && 'INTERFACE|Szklenie' | translate)"
      [buttonText3]="(doorActiveModelBox.type === 'door_panels' && !isPanelTrimsButtonDisabled() && 'DOOR|Listwa' | translate )"
      [buttonText4]="(doorActiveModelBox.type === 'door_panels' && isSlatsAvailable() && 'DOOR|Lamele' | translate )"
      [buttonExpandMore]="(sashHasSlat() && 'DOOR|Usuń lamele' | translate )"
      [descriptionTemplate]="fillingBoxTemplate"
      [descriptionContext]="{box: doorActiveModelBox}"
      [disabledButton1]="isActiveModelButton1Disabled()"
      [disabledButton2]="isActiveModelButton2Disabled()"
      [disabledButton3]="isPanelTrimsButtonDisabled()"
      [disabledButton4]="!isSlatsAvailable()"
      (select)="changeOuterModel('doorActive')"
      (select2)="doorActiveModelBox?.type === 'door_panels' ? changePanelGlazing('doorActive') : openModalDecoPanelOptions('doorActive')"
      (select3)="changePanelTrim('doorActive')"
      (select4)="changeSlat()"
      (selectExpandMore)="removeSlat()"
    ></icc-select-box>
  }
  @if (doorActiveInnerModelBox.show) {
    <icc-select-box
      [title]="doorActiveInnerModelBox?.title"
      [description]="doorActiveInnerModelBox?.name"
      [imageUrl]="doorActiveInnerModelBox?.img"
      [buttonText]="'INTERFACE|Zmień' | translate"
      [buttonText2]="(doorActiveInnerModelBox.type === 'deco_panels' || doorActiveInnerModelBox.type === 'door_panels') && !isPanelTrimsButtonDisabled('doorActiveInner') && 'DOOR|Listwa' | translate"
      [descriptionTemplate]="fillingBoxTemplate"
      [descriptionContext]="{box: doorActiveInnerModelBox}"
      [disabledButton1]="isDoorActiveInnerButton1Disabled()"
      [disabledButton2]="isPanelTrimsButtonDisabled('doorActiveInner')"
      (select)="changeOuterModel('doorActiveInner')"
      (select2)="changePanelTrim('doorActiveInner')"
    ></icc-select-box>
  }
  @if (doorPassiveModelBox?.show) {
    <icc-select-box
      [title]="doorPassiveModelBox?.title"
      [description]="doorPassiveModelBox?.name"
      [imageUrl]="doorPassiveModelBox?.img"
      [buttonText]="'INTERFACE|Zmień' | translate"
      [buttonText2]="((doorPassiveModelBox?.type === 'deco_panels') && 'INTERFACE|Opcje' | translate) || (doorPassiveModelBox?.type === 'door_panels' && 'INTERFACE|Szklenie' | translate)"
      [buttonText3]="(doorPassiveModelBox?.type === 'door_panels' && 'DOOR|Listwa' | translate )"
      [descriptionTemplate]="fillingBoxTemplate"
      [descriptionContext]="{box: doorPassiveModelBox}"
      [disabledButton1]="isPassiveModelButton1Disabled()"
      [disabledButton2]="!doorPassiveModelBox?.showOptions"
      [disabledButton3]="isPanelTrimsButtonDisabled('doorPassive')"
      (select)="changeOuterModel('doorPassive')"
      (select2)="doorPassiveModelBox?.type === 'door_panels' ? changePanelGlazing('doorPassive') : openModalDecoPanelOptions('doorPassive')"
      (select3)="changePanelTrim('doorPassive')"
    ></icc-select-box>
  }
  @if (doorPassiveInnerModelBox.show) {
    <icc-select-box
      [title]="doorPassiveInnerModelBox?.title"
      [description]="doorPassiveInnerModelBox?.name"
      [imageUrl]="doorPassiveInnerModelBox?.img"
      [buttonText]="'INTERFACE|Zmień' | translate"
      [buttonText2]="(doorPassiveInnerModelBox.type === 'deco_panels' || doorPassiveInnerModelBox.type === 'door_panels') && 'DOOR|Listwa' | translate"
      [descriptionTemplate]="fillingBoxTemplate"
      [descriptionContext]="{box: doorPassiveInnerModelBox}"
      [disabledButton1]="isDoorPassiveInnerButton1Disabled()"
      [disabledButton2]="isPanelTrimsButtonDisabled('doorPassiveInner')"
      (select)="changeOuterModel('doorPassiveInner')"
      (select2)="changePanelTrim('doorPassiveInner')"
    ></icc-select-box>
  }
}

<ng-template #fillingBoxTemplate let-box="box">
  @if (box.predefinedLayout) {
    <div class="decoPanels">
      <p class="glassTypeDescription">
        <span><b>{{ 'DOOR|Model:' | translate }}</b>&nbsp;{{box.name}}<br></span>
      </p>
    </div>
  }
  @if (!box.predefinedLayout && box.type === 'deco_panels') {
    <div class="decoPanels">
      @if (box.oneGlazing) {
        <p class="glassTypeDescription"
          >
          @if (box.boxType !== 'doorActiveInner') {
            <span><b>{{ 'DOOR|Rodzaj:' | translate }}</b>&nbsp;
            @if (box.panelType == 'Inset') {
              <span>{{'DOOR|Wypełnienie wsadowe' | translate }}</span>
            }
            @if (box.panelType == 'Outer') {
              <span>{{'DOOR|Nakładka zewnętrzna' | translate }}</span>
            }
            @if (box.panelType == 'Double') {
              <span>{{'DOOR|Nakładka obustronna' | translate }}</span>
            }
            @if (box.panelType == 'Inner') {
              <span>{{'DOOR|Nakładka wewnętrzna' | translate }}</span>
            }
            <br>
            </span>
          }
          <span><b>{{ 'DOOR|Model:' | translate }}</b>&nbsp;{{box.name}}<br></span>
          @if (box.panelGlazingName) {
            <span><b>{{ 'DOOR|Szklenie:' | translate }}</b>&nbsp;{{box.panelGlazingName}}<br></span>
          }
          @if (box.panelTrimName) {
            <span><b>{{ 'DOOR|Listwa zewnętrzna:' | translate }}</b>&nbsp;{{box.panelTrimName}}<br></span>
          }
          @if (box.innerPanelTrimName) {
            <span><b>{{ 'DOOR|Listwa wewnętrzna:' | translate }}</b>&nbsp;{{box.innerPanelTrimName}}<br></span>
          }
          <span><b>{{ 'DOOR|Kolor wypełnienia:' | translate }}</b>&nbsp;{{box.color}}<br></span>
          @if (box.color2) {
            <span><b>{{ 'DOOR|Kolor wypełnienia 2:' | translate }}</b>&nbsp;{{box.color2}}<br></span>
          }
        </p>
      }
      @if (box.panelType != 'Outer' && !box.oneGlazing) {
        <p class="glassTypeDescription">
          {{ 'DOOR|Różne panele w poszczególnych kwaterach, szczegóły w podsumowaniu.' | translate }}
        </p>
      }
    </div>
  }
  @if (!box.predefinedLayout && box.type === 'door_panels') {
    <div class="doorPanels">
      <p class="glassTypeDescription">
        <span><b>{{ 'DOOR|Model:' | translate }}</b>&nbsp;{{box.name}}<br></span>
        @if (box.panelGlazingName) {
          <span><b>{{ 'DOOR|Szklenie:' | translate }}</b>&nbsp;{{box.panelGlazingName}}<br></span>
        }
        @if (box.panelTrimName) {
          <span><b>{{ 'DOOR|Listwa:' | translate }}</b>&nbsp;{{box.panelTrimName}}<br></span>
        }
      </p>
    </div>
  }
  @if (!box.predefinedLayout && box.type === 'glazing') {
    <div class="glazing">
      @if (box.oneGlazing) {
        <p class="glassTypeDescription">
          <span><b>{{ 'DOOR|Szklenie:' | translate }}</b>&nbsp;{{box.name}}<br></span>
          @if (box.color) {
            <span><b>{{ 'DOOR|Kolor wypełnienia:' | translate }}</b>&nbsp;{{box.color}}<br></span>
          }
        </p>
      } @else {
        <p class="glassTypeDescription">
          {{ 'DOOR|Różne wypełnienia w poszczególnych kwaterach, szczegóły w podsumowaniu.' | translate }}
        </p>
      }
    </div>
  }
</ng-template>
